import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import AddUserModal from './AddUser';
import { toast } from 'react-toastify';

const Content = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);

    const url = process.env.REACT_APP_LINK
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null); // "approve" | "reject"
    const [selectedId, setSelectedId] = useState(null);
    const [youtubeLink, setYoutubeLink] = useState("");
    const [rejectReason, setRejectReason] = useState("");
    const token = localStorage.getItem("token")
    const openModal1 = (id, type) => {
        setSelectedId(id);
        setModalType(type);
        setModalOpen(true);
    };

    const handleSubmit = async () => {
        let payload = { id: selectedId, staff_type: true, status: modalType === "approve" ? "Approved" : "Rejected" };
        if (modalType === "approve") payload.youtube_link = youtubeLink;
        if (modalType === "reject") payload.reason = rejectReason;

        // Call backend API
        await fetch(`${url}/api/videos/change/staff/${selectedId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(payload),
        });

        // Update UI
        setEmployees((prev) =>
            prev.map((item) => (item.id === selectedId ? { ...item, ...payload } : item))
        );
        fetchUsers();

        // Reset + close
        setYoutubeLink("");
        setRejectReason("");
        setModalOpen(false);
    };
    const [data, setData] = useState({
        email: "",
        password: "",
        full_name: "",
        mobile: ""
    })

    const [selected, setSelected] = useState(null);
    const [isOpen, setIsOpen] = useState(false);


    function openModal(video) {
        setSelected(video);
        setIsOpen(true);
        document.body.style.overflow = "hidden";
    }


    function closeModal() {
        setIsOpen(false);
        setSelected(null);
        document.body.style.overflow = "auto";
    }


    const renderTags = (tags) => {
        try {
            const arr = typeof tags === "string" ? JSON.parse(tags) : tags || [];
            if (!Array.isArray(arr)) return [];
            return arr;
        } catch (e) {
            return [];
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/videos/staff`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await response.json();
            setEmployees(data.reverse());
            console.log(data)
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    // Fetch users from backend
    useEffect(() => {


        fetchUsers();
    }, []);

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const filtered = employees
        .filter((employee) => !employee.archieve) 
        .filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const isEdit = data.id !== undefined;
    //     const url = isEdit
    //         ? `${url}/api/user/change/${data.id}`
    //         : `${url}/api/user/signup`;
    //     const method = isEdit ? 'PUT' : 'POST';

    //     const payload = {
    //         email: data.email,
    //         password: data.password || null,
    //         full_name: data.full_name || null,
    //         mobile: data.mobile,
    //         //    end_date: data.end,
    //         //    used_by: data.used_by,
    //         //    status: data.status?.value
    //     };

    //     try {
    //         const res = await fetch(url, {
    //             method,
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(payload)
    //         });

    //         const result = await res.json();
    //         if (res.ok) {
    //             const mappedResult = {
    //                 id: result.id,
    //                 email: result.email,
    //                 password: result.password,
    //                 full_name: result.full_name,
    //                 mobile: result.mobile,

    //             };


    //             toast.success(isEdit ? 'Coupon updated' : 'Coupon added');
    //             //    fetchCoupon();
    //             // setCoupons(prev => isEdit
    //             //     ? prev.map(c => c.id === result.id ? mappedResult : c)
    //             //     : [...prev, mappedResult]
    //             // );

    //             fetchUsers();
    //             setIsModalOpen(false);
    //             setData({
    //                 email: "",
    //                 password: "",
    //                 full_name: "",
    //                 mobile: "",

    //             });
    //         } else {
    //             toast.error(result.message || "Save failed");
    //         }
    //     } catch (err) {
    //         toast.error("Server error");
    //         console.error(err);
    //     }
    // };
    const handleDelete = (email) => {
        const updatedEmployees = employees.filter(employee => employee.email !== email);
        setEmployees(updatedEmployees);
    };

    const handleStatusChange = (id, status) => {
        setEmployees((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, status } : item
            )
        );

        // Optional: call API here to update in DB
        // axios.post(`/api/videos/update-status/${id}`, { status });
    };



    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Content</h1>
                    {/* <button className="oms-add-btn" onClick={() => {
                        setIsModalOpen(true)
                        setData({
                            email: "",
                            password: "",
                            full_name: "",
                            mobile: "",

                        });
                    }}>
                        Add User
                    </button> */}
                </div>
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                {/* <th>Description</th> */}
                                <th>Category</th>
                                <th>Pay Status</th>
                                {/* <th>Tags</th> */}
                                <th>Audience</th>
                                {/* <th>Vimeo Link</th> */}
                                <th>Created</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((video, index) => (
                                    <tr key={index}>
                                        <td onClick={() => {
                                            openModal(video)
                                            console.log("hiiii")
                                        }}
                                            style={{ cursor: "pointer" }}
                                            className="truncate">{video.title}</td>
                                        {/* <td className="truncate">{video.description}</td> */}
                                        <td>{video.category}</td>
                                        <td>{video.pay_status}</td>
                                        {/* <td className="truncate">{JSON.parse(video.tags).join(", ")}</td> */}
                                        <td>{video.audience}</td>
                                        {/* <td>
                                            <a
                                                href={video.vimeo_link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View
                                            </a>
                                        </td> */}
                                        <td>{new Date(video.createdAt).toLocaleString()}</td>
                                        <td className="releases-action-buttons">
                                            <button
                                                className={`releases-approve ${video.status === "Approved" ? "active" : ""}`}
                                                onClick={() => openModal1(video.id, "approve")}
                                            >
                                                Approve
                                            </button>
                                            <button
                                                className={`releases-reject ${video.status === "Rejected" ? "active" : ""}`}
                                                onClick={() => openModal1(video.id, "reject")}
                                            >
                                                Reject
                                            </button>

                                        </td>


                                        <td>
                                            <button
                                                onClick={async () => {
                                                    const res = await fetch(`${url}/api/videos/downloadvideo/${video.vimeo_uri.split('/').pop()}`);
                                                    const data = await res.json();
                                                    if (data.url) {
                                                        window.open(data.url, "_blank"); // open or force download
                                                    }
                                                }}
                                                className="download-button">Download</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center" }}>
                                        No videos found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>


                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>



                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>




            {/* Modal */}
            {isOpen && selected && (
                <div className="releases-modal-overlay" onClick={closeModal}>
                    <div className="releases-modal" onClick={(e) => e.stopPropagation()}>
                        <header className="releases-modal-header">
                            <h2 className="releases-modal-title">{selected.title}</h2>
                            <button className="releases-modal-close" onClick={closeModal} aria-label="Close">
                                ×
                            </button>
                        </header>

                        <div className="releases-modal-body">
                            <div className="releases-left">
                                <div className="releases-thumb">
                                    {selected.thumbnail_path ? (
                                        <img src={`${url}${selected.thumbnail_path}`} alt={selected.title} />
                                    ) : (
                                        <div className="releases-thumb-placeholder">No Thumbnail</div>
                                    )}
                                </div>

                                <div className="releases-meta">
                                    <div><strong>Category:</strong> {selected.category}</div>
                                    <div><strong>Audience:</strong> {selected.audience}</div>
                                    <div><strong>Pay Status:</strong> {selected.pay_status || 'N/A'}</div>
                                    <div><strong>Created:</strong> {new Date(selected.createdAt).toLocaleString()}</div>
                                    <div><strong>Updated:</strong> {new Date(selected.updatedAt).toLocaleString()}</div>
                                    <div className="releases-tags"><strong>Tags:</strong> {renderTags(selected.tags).join(', ') || '-'}</div>
                                </div>

                                <div className="releases-actions">
                                    <a href={selected.vimeo_link} target="_blank" rel="noreferrer" className="releases-action-btn">Open Vimeo</a>
                                    <button className="releases-action-btn secondary" onClick={async () => {
                                        const res = await fetch(`${url}/api/videos/downloadvideo/${selected.vimeo_uri.split('/').pop()}`);
                                        const data = await res.json();
                                        if (data.url) {
                                            window.open(data.url, "_blank"); // open or force download
                                        }
                                    }}
                                    >Download</button>
                                </div>
                            </div>

                            <div className="releases-right">
                                <h3 className="releases-section-title">Description</h3>
                                <div className="releases-description">{selected.description || 'No description provided.'}</div>

                                <h3 className="releases-section-title">Extra Details</h3>
                                <div className="releases-grid">
                                    {/* <div className="releases-grid-item"><strong>ID</strong><span>{selected.id}</span></div> */}
                                    {/* <div className="releases-grid-item"><strong>Vimeo Uri</strong><span>{selected.vimeo_uri}</span></div> */}
                                    <div className="releases-grid-item"><strong>Youtube Link</strong><span>{selected.youtube_video_link || '-'}</span></div>
                                    <div className="releases-grid-item"><strong>Rejected Reason</strong><span>{selected.rejected_reason || '-'}</span></div>
                                    <div className="releases-grid-item"><strong>Video Status</strong><span>{selected.status || '-'}</span></div>
                                    <div className="releases-grid-item"><strong>Pay ID</strong><span>{selected.pay_id || '-'}</span></div>
                                    {/* <div className="releases-grid-item full-width"><strong>Raw Data</strong><pre className="releases-raw">{JSON.stringify(selected, null, 2)}</pre></div> */}
                                </div>
                            </div>
                        </div>

                        <footer className="releases-modal-footer">
                            <button className="releases-close-btn" onClick={closeModal}>Close</button>
                        </footer>
                    </div>
                </div>
            )}


            {modalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-lg w-96">
                        <h2 className="text-lg font-bold mb-4">
                            {modalType === "approve" ? "Approve Video" : "Reject Video"}
                        </h2>

                        {modalType === "approve" && (
                            <input
                                type="text"
                                placeholder="Enter YouTube link"
                                value={youtubeLink}
                                onChange={(e) => setYoutubeLink(e.target.value)}
                                className="w-full border p-2 rounded mb-4"
                            />
                        )}

                        {modalType === "reject" && (
                            <textarea
                                placeholder="Enter rejection reason"
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                                className="w-full border p-2 rounded mb-4"
                            />
                        )}

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setModalOpen(false)}
                                className="px-4 py-2 bg-gray-300 rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={async () => {
                                    let payload = { id: selectedId, status: modalType === "approve" ? "Approved" : "Rejected" };
                                    if (modalType === "approve") payload.youtube_link = youtubeLink;
                                    if (modalType === "reject") payload.reason = rejectReason;

                                    // ✅ Call backend API
                                    await fetch(`${url}/api/videos/change/${selectedId}`, {
                                        method: "POST",
                                        headers: { "Content-Type": "application/json" },
                                        body: JSON.stringify(payload),
                                    });

                                    // Update state locally
                                    setEmployees((prev) =>
                                        prev.map((item) =>
                                            item.id === selectedId ? { ...item, ...payload } : item
                                        )
                                    );

                                    setModalOpen(false);
                                    setYoutubeLink("");
                                    setRejectReason("");
                                }}
                                className="px-4 py-2 bg-blue-600 text-white rounded"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {modalOpen && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h2>{modalType === "approve" ? "Approve Video" : "Reject Video"}</h2>

                        {modalType === "approve" && (
                            <input
                                type="text"
                                placeholder="Enter YouTube link"
                                value={youtubeLink}
                                onChange={(e) => setYoutubeLink(e.target.value)}
                            />
                        )}

                        {modalType === "reject" && (
                            <textarea
                                placeholder="Enter rejection reason"
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                            />
                        )}

                        <div className="modal-actions">
                            <button onClick={() => setModalOpen(false)} className="cancel-btn">
                                Cancel
                            </button>
                            <button onClick={handleSubmit} className="submit-btn">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}


            <AddUserModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={data}
                setCouponForm={setData}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
            />


        </>
    );
};

export default Content;
